export default __webpack_public_path__ + "static/media/FP_F.ed65baa6.png";